export default "__VITE_ASSET__BI6kV$a7__"